// Central asset registry: module title -> { videoId, image, outcomes }
// Lookup is case-insensitive on the exact module title used across the app.

// -------- VIDEOS ----------------------------------------------------
const VIDEOS_RAW = {
  'Perimeter':               'PQ9-y2QOVFE',
  'Area 2D':                 'uvY_WJbskTY',
  'Zero Gravity':            'zZFAAM1RjAM',
  'Sound':                   'Ha42Bc3wK-E',
  'Gyan Prangan':            'KeaSrwPR9SE',
  "Gravity's Grip":          'cjhhWWrbDQw',
  'Human Excretory System':  '5ZC3dh-BuHA',
  'Friction':                'm98s1a5uki8',
  'Falltopia':               '_F2VwPq0-M4',
  'Gyan Mitra':              'gkkQmHcfvlo',
};

// Featured platform videos (used for branded placeholders)
export const FEATURED_VIDEO_ID = 'AzQDeSmaDdA'; // Gyan Dhara — dedicated hero video

export const MODULE_VIDEOS = Object.fromEntries(
  Object.entries(VIDEOS_RAW).map(([k, v]) => [k.toLowerCase(), v])
);

export function getModuleVideoId(title) {
  if (!title) return null;
  return MODULE_VIDEOS[String(title).toLowerCase()] || null;
}

export function youtubeThumb(videoId, quality = 'hqdefault') {
  return `https://img.youtube.com/vi/${videoId}/${quality}.jpg`;
}

// -------- IMAGES ---------------------------------------------------
// User-uploaded module images. Add new URLs as they become available.
const IMAGES_RAW = {
  'Living World Safari':      'https://customer-assets-rejwkqb3.emergentagent.net/job_wix-redesign-2/artifacts/zpnzjoof_Living%20World%20Safari.webp',
  'Lost World Expedition':    'https://customer-assets-rejwkqb3.emergentagent.net/job_wix-redesign-2/artifacts/8qwpoadu_Lost%20World%20Expedition.webp',
  'Age of Dinosaurs':         'https://customer-assets-rejwkqb3.emergentagent.net/job_wix-redesign-2/artifacts/llkors0m_Age%20of%20Dinasaurs.webp',
  'India Gate':               'https://customer-assets-rejwkqb3.emergentagent.net/job_wix-redesign-2/artifacts/auzp7lcs_IndiaGate.webp',
  'Taj Mahal':                'https://customer-assets-rejwkqb3.emergentagent.net/job_wix-redesign-2/artifacts/kg0w9kxn_Tajmahal.webp',
  'Volume':                   'https://customer-assets-rejwkqb3.emergentagent.net/job_wix-redesign-2/artifacts/wnbtr5l3_Volume%203D.webp',
  'Pollinator Park':          'https://customer-assets-rejwkqb3.emergentagent.net/job_wix-redesign-2/artifacts/inar4hzz_Pollinator%20Park.png',
  'Experience Space Station': 'https://customer-assets-rejwkqb3.emergentagent.net/job_wix-redesign-2/artifacts/x0opts98_Experience%20Space%20Station.png',
  'Anne Frank Experience':    'https://customer-assets-rejwkqb3.emergentagent.net/job_wix-redesign-2/artifacts/bzvic1dj_Anne%20Frank.png',
  'Notes on Blindness':       'https://customer-assets-rejwkqb3.emergentagent.net/job_wix-redesign-2/artifacts/p3q13u5d_Notes%20on%20Blindness.png',
  'Combustion & Flame':       'https://customer-assets-rejwkqb3.emergentagent.net/job_wix-redesign-2/artifacts/4ejpkh88_Combustion%20%26%20Flame.webp',
  'AeroQuest':                'https://customer-assets-rejwkqb3.emergentagent.net/job_wix-redesign-2/artifacts/4go49s9d_AeroQuest.webp',
  'Energy':                   'https://customer-assets-rejwkqb3.emergentagent.net/job_wix-redesign-2/artifacts/zyu05i24_Energy.webp',
  'Area 3D':                  'https://customer-assets-rejwkqb3.emergentagent.net/job_wix-redesign-2/artifacts/dstwusbo_Area%203D.webp',
  '3D Painting':              'https://customer-assets-rejwkqb3.emergentagent.net/job_wix-redesign-2/artifacts/nhgif81l_3D%20painting.png',
  'Work':                     'https://customer-assets-rejwkqb3.emergentagent.net/job_wix-redesign-2/artifacts/aj0zygiv_Work.webp',
  'Qutub Minar':              'https://customer-assets-rejwkqb3.emergentagent.net/job_wix-redesign-2/artifacts/gbuqicxr_Qutub%20Minar.webp',
  'Structure of Atom':        'https://customer-assets-rejwkqb3.emergentagent.net/job_wix-redesign-2/artifacts/8y1rgl55_Structure%20of%20Atom.jpeg',
  'Structure of Atoms':       'https://customer-assets-rejwkqb3.emergentagent.net/job_wix-redesign-2/artifacts/8y1rgl55_Structure%20of%20Atom.jpeg',
  'Area of Cone':             'https://customer-assets-rejwkqb3.emergentagent.net/job_wix-redesign-2/artifacts/zdtwxp31_Area%20of%20Cone.jpeg',
  'Area of Sphere':           'https://customer-assets-rejwkqb3.emergentagent.net/job_wix-redesign-2/artifacts/qlnf83bu_Area%20of%20Sphere.jpeg',
  'Volume of Sphere and Cone':'https://customer-assets-rejwkqb3.emergentagent.net/job_wix-redesign-2/artifacts/dkfxoqva_Volume%20of%20sphere%20and%20cone.jpeg',
};

export const MODULE_IMAGES = Object.fromEntries(
  Object.entries(IMAGES_RAW).map(([k, v]) => [k.toLowerCase(), v])
);

export function getModuleImage(title) {
  if (!title) return null;
  return MODULE_IMAGES[String(title).toLowerCase()] || null;
}

// -------- LEARNING OUTCOMES ---------------------------------------
// Max 3 outcomes per module. Presented as bullets in the lightbox.
// Curriculum-aligned starter copy — edit freely.
const OUTCOMES_RAW = {
  'Combustion & Flame': [
    'Identify combustible and non-combustible substances in the environment.',
    'Compare rapid, slow and spontaneous types of combustion with examples.',
    'Describe the three zones of a candle flame and their temperatures.',
  ],
  'AeroQuest': [
    "Understand how air pressure and Bernoulli's principle enable flight.",
    'Compare the forces of lift, drag, thrust and weight acting on aircraft.',
    'Explore how wing design and airflow influence aerodynamic behaviour.',
  ],
  'Work': [
    'Define the scientific concept of work and its SI unit (joule).',
    'Identify situations where work is done and where no work is done.',
    'Compute work done using force and displacement in familiar scenarios.',
  ],
  'Energy': [
    'Distinguish between kinetic and potential energy through everyday examples.',
    'Observe energy transformations across mechanical systems.',
    'Apply the law of conservation of energy in simple physical setups.',
  ],
  'Area 3D': [
    'Visualise surface area on cubes, cuboids, cylinders and spheres.',
    'Derive and apply formulas for the surface area of common 3D shapes.',
    'Solve applied problems involving surface area in daily contexts.',
  ],
  'Volume': [
    'Understand volume as space occupied by a three-dimensional object.',
    'Calculate the volume of cubes, cuboids and cylinders using standard formulas.',
    'Compare and relate volume with capacity in real-world containers.',
  ],
  'Taj Mahal': [
    'Explore the architectural style and symmetry of the Taj Mahal.',
    'Understand the historical context of its construction under Shah Jahan.',
    'Appreciate the craftsmanship, materials and inlay artistry of Mughal architecture.',
  ],
  'Qutub Minar': [
    'Learn the layered construction and Indo-Islamic architecture of Qutub Minar.',
    'Trace the timeline from Qutb-ud-din Aibak to later sultans who expanded it.',
    'Observe the calligraphy, iron pillar and surrounding Qutb complex.',
  ],
  'India Gate': [
    'Understand India Gate as a national memorial to Indian soldiers.',
    'Explore the significance of the Amar Jawan Jyoti and inscribed names.',
    'Appreciate the memorial architecture and its role in national remembrance.',
  ],
  'Age of Dinosaurs': [
    'Observe how dinosaurs lived, hunted and moved millions of years ago.',
    'Compare herbivorous and carnivorous species and their habitats.',
    'Understand the events that led to their extinction and fossil evidence.',
  ],
  'Lost World Expedition': [
    'Explore extinct megafauna and the environments they once inhabited.',
    'Understand how climate, geography and ecosystems have changed over time.',
    'Trace fossil evidence and how scientists reconstruct lost worlds.',
  ],
  'Living World Safari': [
    'Observe how animals from different biomes live, survive and adapt in nature.',
    'Compare species behaviour across grassland, forest and savannah ecosystems.',
    'Appreciate biodiversity and the interdependence of species in an ecosystem.',
  ],
  'Experience Space Station': [
    'Explore what daily life looks like aboard the International Space Station.',
    'Understand microgravity effects on movement, sleep and simple tasks.',
    'Trace the collaborative science that happens in low-Earth orbit.',
  ],
  '3D Painting': [
    'Experience creative expression by painting in three-dimensional space.',
    'Explore colour, form and depth through immersive interaction.',
    'Build spatial awareness and artistic confidence through play.',
  ],
  'Anne Frank Experience': [
    'Walk through the Secret Annex and understand life in hiding during WWII.',
    "Learn about Anne Frank's story, her diary and its historical significance.",
    'Reflect on themes of resilience, empathy and human rights.',
  ],
  'Notes on Blindness': [
    'Experience the perceptual world through the perspective of a blind narrator.',
    'Understand how the mind reconstructs space without sight.',
    'Reflect on accessibility, empathy and different sensory experiences.',
  ],
  'Pollinator Park': [
    'Explore the vital role of pollinators — bees, butterflies and birds — in ecosystems.',
    'Understand the causes and consequences of pollinator decline.',
    'Discover how habitat design supports biodiversity and food security.',
  ],
};

export const MODULE_OUTCOMES = Object.fromEntries(
  Object.entries(OUTCOMES_RAW).map(([k, v]) => [k.toLowerCase(), v])
);

export function getModuleOutcomes(title) {
  if (!title) return null;
  return MODULE_OUTCOMES[String(title).toLowerCase()] || null;
}


// Modules for which only English is currently available.
// Everything else defaults to the tri-lingual chip 'EN / HI / AS'.
const EN_ONLY_TITLES = new Set([
  'zero gravity',
  "gravity's grip",
  'aeroquest',
  'falltopia',
  'human excretory system',
  'pollinator park',
  'friction',
  'experience space station',
  '3d painting',
  'anne frank house',
  'anne frank experience',
  'notes on blindness',
]);

export function getModuleLanguage(title) {
  return EN_ONLY_TITLES.has(String(title).toLowerCase()) ? 'EN' : 'EN / HI / AS';
}
